import React from "react";
import Button from "apollo-react/components/Button";
import ConversationChat from "apollo-react-icons/ConversationChat";
import UserCircle from "apollo-react-icons/UserCircle";

// Status badge component
const StatusBadge = ({ status }) => {
  let className = "status-badge ";
  switch (status) {
    case "In Review":
      className += "status-in-review";
      break;
    case "Approved":
      className += "status-approved";
      break;
    case "Rejected":
      className += "status-rejected";
      break;
    case "Sent Back":
      className += "status-sent-back";
      break;
    default:
      className += "status-default";
  }
  return <span className={className}>{status}</span>;
};

// Reviewer component
const ReviewerInfo = ({ reviewer }) => (
  <div className="reviewer-container">
    <div className="reviewer-avatar">
      <UserCircle size={24} color="#6b7280" />
    </div>
    <span>{reviewer}</span>
  </div>
);

// Comment action component
const CommentAction = ({ row, onCommentIconClick }) => (
  <div className="comment-action-container">
    <button
      onClick={(e) => onCommentIconClick(row, e)}
      className="comment-action-button"
    >
      <ConversationChat size={16} color="#666" />
    </button>
  </div>
);

// Send Back Privately button component - only shown when action has happened
const SendBackPrivatelyButton = ({ status }) => {
  // Don't show button if no action has happened (status is "-" or empty)
  if (!status || status === "-") {
    return null;
  }

  return (
    <Button
      variant="outlined"
      size="small"
      disabled
      sx={{ minWidth: "110px", flexShrink: 0 }}
    >
      Comment Privately
    </Button>
  );
};

// Table columns configuration
export const getTableColumns = (onCommentIconClick) => {
  const columns = [
    {
      field: "id",
      header: "ID",
      body: (row) => row.id,
    },
    {
      field: "process",
      header: "Process",
      body: (row) => row.process,
    },
    {
      field: "status",
      header: "Status",
      body: (row) => <StatusBadge status={row.status} />,
    },
    {
      field: "reviewer",
      header: "Reviewer",
      body: (row) => <ReviewerInfo reviewer={row.reviewer} />,
    },
    {
      field: "sendBackPrivately",
      header: "Actions",
      body: (row) => <SendBackPrivatelyButton status={row.status} />,
    },
  ];

  if (onCommentIconClick) {
    columns.push({
      field: "actions",
      header: "Comment Actions",
      body: (row) => (
        <CommentAction row={row} onCommentIconClick={onCommentIconClick} />
      ),
    });
  }
  return columns;
};
